import { render } from "./StaticDatenschutz.vue?vue&type=template&id=78754fa2"
import script from "./StaticDatenschutz.vue?vue&type=script&lang=js"
export * from "./StaticDatenschutz.vue?vue&type=script&lang=js"

import "./StaticDatenschutz.vue?vue&type=style&index=0&id=78754fa2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__